import { isArray } from "lodash";
import axios from 'axios';

// Dynamically import all images from the images folder
const imageModules = import.meta.glob('../images/*.png', { eager: true, import: 'default' });


class dsd{

    StateObject = null;

    config = {

        Features :[
            {
                label:"Solutions",
                description:"Define Roles, Capabilities and Systems",
                link:"/solutions"
            },
/*            
            {
                label:"Designs",
                description:"Define Design Items",
                link:"/designs"
            },
*/
            {
                label:"Concept Models",
                description:"Define Concepts and Links",
                link:"/conceptmodels"
            },
            {
                label:"Logical Models",
                description:"Define Entities and Relationships",
                link:"/logicalmodels"
            },
            {
                label:"Data Dictionaries",
                description:"Define reuseable Data Structures, and Enumerations",
                link:"/datadictionaries"
            },
            {
                label:"Code Lists",
                description:"Define structured sets of predefined codes",
                link:"/codelists"
            },
            {
                label:"Data Specifications",
                description:"Define Messages and Schemas",
                link:"/dataspecs"
            },
            {
                label:"Interfaces",
                description:"Define APIs",
                link:"/interfaces"
            },
            {
                label:"Processes",
                description:"Define Steps and Flows",
                link:"/processes"
            },
            {
                label:"Artefacts",
                description:"Define items that are used in a Process",
                link:"/artefacts"
            },
            {
                label:"Resources",
                description:"Define a Resources that are used in a Process",
                link:"/resources"
            },
            {
                label:"Narratives",
                description:"Tell stories using definitions",
                link:"/narratives"
            }

        ],

        ComponentStatuses :[
            'under construction',
            'private',
            'published',
            'deprecated'
            ],
    
        ProcessStatuses :[
        'under construction',
        'private',
        'published',
        'deprecated'
        ],
        ArtefactStatuses :[
            'under construction',
            'private',
            'published',
            'deprecated'
        ],
        ArtefactUses :[
            'input',
            'output',
            'updated'
        ],

        ResourceStatuses :[
            'under construction',
            'private',
            'published',
            'deprecated'
        ],

        ConceptStatuses :[
            'in use',
            'deprecated'
        ],

        ItemStatuses :[
            'in use',
            'deprecated'
        ],

        LinkStatuses :[
            'in use',
            'deprecated'
        ],

        EntityStatuses :[
            'in use',
            'deprecated'
        ],

        RelationshipStatuses :[
            'in use',
            'deprecated'
        ],

        RelationshipCardinalities :[
            'one to one',
            'one to many',
            'many to many'
        ],

        StructureStatuses :[
            'in use',
            'deprecated'
        ],

        RoleStatuses :[
            'in use',
            'deprecated'
        ],

        SystemStatuses :[
            'in use',
            'deprecated'
        ],

        CapabilityStatuses :[
            'in use',
            'deprecated'
        ],

        CapabilityTypes :[
            'Digital',
            'Activity',
            'Interface',
            'Group'
        ],

        ParticipationStatuses :[
            'in use',
            'deprecated'
        ],

        DependencyTypes :[
            'calls',
            'requires',
            'can use'
        ],


        xDataTypes :[
            'line',
            'text',
            'number',
            'currency',
            'date',
            'yes/no',
            'lookup'
        ],


        "DataTypes" : {
            "line":{"type":"xsd:string","json_type":"string"},
            "text":{"type":"xsd:string","json_type":"string"},
            "markdown":{"type":"xsd:string","json_type":"string", "rdfs_range":"rdfs:Literal"},
            "number":{"type":"xsd:decimal","json_type":"number"},
            "integer":{"type":"xsd:integer","json_type":"number", "json_multipleOf" : 0.01},
            "currency":{"type":"xsd:decimal","json_type":"integer"},
            "date":{"type":"xsd:date", "json_type":"string", "json_format":"date"},
            "time":{"type":"xsd:time","json_type":"string", "json_format":"time"},
            "datetime":{"type":"xsd:dateTime", "json_type":"string", "json_format":"date-time"},
            "timestamp":{"type":"xsd:dateTime", "json_type":"string", "json_format":"date-time"},
            "URI":{"type":"xsd:anyURI","json_type":"string", "json_format":"uri"},
            "URL":{"type":"xsd:anyURI","json_type":"string", "json_format":"uri-reference"},
            "URN":{"type":"xsd:anyURI","json_type":"string", "json_format":"uri"},
            "yes/no":{"type":"xsd:boolean","json_type":"boolean"},
            "lookup":{"type":"xsd:string","json_type":"string"}
        },


        "ParameterDataTypes" : {
            "line":{"type":"xsd:string","json_type":"string"},
            "number":{"type":"xsd:decimal","json_type":"number"},
            "integer":{"type":"xsd:integer","json_type":"number", "json_multipleOf" : 0.01},
            "currency":{"type":"xsd:decimal","json_type":"number", "json_multipleOf" : 0.01},
            "date":{"type":"xsd:date", "json_type":"string", "json_format":"date"},
            "time":{"type":"xsd:time","json_type":"string", "json_format":"time"},
            "datetime":{"type":"xsd:dateTime", "json_type":"string", "json_format":"date-time"},
            "URI":{"type":"xsd:anyURI","json_type":"string", "json_format":"uri"},
            "URL":{"type":"xsd:anyURI","json_type":"string", "json_format":"uri-reference"},
            "URN":{"type":"xsd:anyURI","json_type":"string", "json_format":"uri"},
            "yes/no":{"type":"xsd:boolean","json_type":"boolean"},
            "lookup":{"type":"xsd:string","json_type":"string"}
        },

        Occurs :[
            'once',
            'many',
        ],

        Required :[
            'yes',
            'no',
        ],

        TermTypeStatuses :[
            'in use',
            'deprecated'
        ],

        EnumerationStatuses :[
            'in use',
            'deprecated'
        ],


        RoleTypes : {
            human:{
                label:"human",
                image:"human.png"
            },
            organisation:{
                label:"organisation",
                image:"organisation.png"
            },
            "interface": {
                "label":"interface",
                "image":"interface.png"
            },
            dataset: {
                label:"dataset",
                image:"dataset.png"
            },
            "digital agent":{
                "label":"digital agent",
                "image":"digital_agent.png"
            },
            other:{
                label:"other",
                image:"stick.png"
            },

        },

        ParticipationTypes : {
            initiation:{
                label:"initiation"
            },
            communication: {
                label:"communication"
            }
        },

        ClassSourceTypes : [
            'entity',
            'relationship',
            'unmodeled'
        ],

        ParameterWheres : [
            'query',
            'header',
            'path',
            'cookie'
        ]


    }


    constructor(parent) {


        let urlOrigin = window.location.origin;
        let urlParts = new URL(urlOrigin);
    
        let urlAPI = `${urlParts.protocol}//${urlParts.hostname}/api/dsd`;

        if (urlParts.hostname == 'localhost'){
            urlAPI = `${urlParts.protocol}//${urlParts.hostname}:5050`;
        }
// for single word local machine names ... so not over an intranet
        if ((urlParts.hostname.split(".").length) == 1){
            urlAPI = `${urlParts.protocol}//${urlParts.hostname}:5050`;
        }
        if (urlParts.hostname.startsWith('192.168')){
            urlAPI = `${urlParts.protocol}//${urlParts.hostname}:5050`;
        }


//////        urlAPI = 'http://52.56.166.229/api/dsd';

        this.httpConfig = axios.create({
            baseURL: urlAPI,
            headers: {
              "Content-type": "application/json"
            }
        });

        if (parent){
            this.StateObject = parent;
        }

        this.user = null;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.loggedon = false;
    
        if (this.user){
            if (this.user.hasOwnProperty("id")){
                this.loggedon = true;
            }
        }
    
        if (global.model){
            this.model = global.model;
        }
        else{
            this.getModel();
        }

    }


    uriDereference(uri=null,  onDone , onError){

        let headers = {
            headers: 
                {
                    "Content-type": "text/html"
                }
            }

        let authHeader = this.authHeader();
        if (authHeader){
            headers.headers.Authorization = authHeader.Authorization;
        }

        if (uri.startsWith("http://def.")){
            let urlParts = new URL(uri);
            uri = `/dereference${urlParts.pathname}`;    
        }

        return(

            this.httpConfig.get(uri, headers)
                .then(response => {
                    if (onDone){
                        onDone(response.data)
                    }
                })
                .catch(e => {
                    if (onError){
                        onError(e)
                    }
                    console.log(e);
                })
        );

    };


    getSolutionImages(){

        let images = [];
        for (let idRoleType in this.config.RoleTypes){
            let image = {};
            image.filename = this.config.RoleTypes[idRoleType].image;
            
            // Dynamically load the image based on filename
            const imagePath = `../images/${image.filename}`;
            image.object = imageModules[imagePath] || imageModules['../images/stick.png'];
            
            image.height = "50px";
            image.width = "50px";
            images.push(image);
        }

        // Add interface.png for Interface-type Capabilities
        let interfaceImage = {};
        interfaceImage.filename = "interface.png";
        interfaceImage.object = imageModules['../images/interface.png'];
        interfaceImage.height = "50px";
        interfaceImage.width = "50px";
        images.push(interfaceImage);

        return images;

    }

    async getModel() {
        const headers = {
            headers: {
            "Content-type": "application/json",
            },
        };

        try {
            if (!this.httpConfig?.get) {
                throw new Error("httpConfig not initialised");
            }

            const response = await this.httpConfig.get("/model", headers);
            this.model = response.data;
            global.model = this.model;
            this.StateObject?.setState?.({ ModelLoaded: true });
        } catch (e) {
            this.StateObject?.setState?.({ isFailed: true });
            console.log(e);
        }
    }

    authHeader(){


        let user = JSON.parse(localStorage.getItem('user'));

       if (user && user.authdata) {
           return { 'Authorization': 'Basic ' + user.authdata };
       } else {
           return {};
       }
   };


};



export default dsd;